import React, { useState, useEffect } from "react";
import axios from "axios";
//forms component
import Wilayah from "./wilayah";
import Keluarga from "./keluarga";
import PUS from "./pus";
import PUSLAINNYA from "./pus-lainnya";
import KB from "./kb";
import PK from "./pk";
import HAMILLAINNYA from "./pus-lainnya/hamil";
// import PERTANYAAN from './pertanyaan';
import Finish from "./finish";

// material-ui components
import Slide from "@material-ui/core/Slide";
// import Typography from '@material-ui/core/Typography';
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";

import useStyles from "./styles/index";

import { useParams, useHistory } from "react-router-dom";
import { usePouchDB } from "../../../components/PouchDB/PouchDBProvider";
import { useDataSync } from "../../../components/PouchDB/DataSyncProvider";
import { useSnackbar } from "notistack";
import { Alert } from "reactstrap";

import AppPageLoading from "../../../components/AppPageLoading";

import lodashGet from "lodash/get";
import { countAge } from "./pk/validation";

import beautyKB from "./kb/beauty";
import beautyPK from "./pk/beauty";
import beauty from "./kb/beauty";

import differenceInCalendarDays from "date-fns/differenceInCalendarDays";
import parseDate from "date-fns/parse";
import { formatString } from "./keluarga";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

export default function EditForm(mode) {
  const USER_KEY_PG = process.env.REACT_APP_USER_KEY_PROXY_GATEWAY;
  const db_name = localStorage.getItem("db_name");
  const remote_base = localStorage.getItem("remote_base");
  const url = remote_base + "/" + db_name;
  const url_split = remote_base ? remote_base.split("/") : "";
  const couchdb = url_split[url_split.length - 1];

  //
  const classes = useStyles();
  const params = useParams();
  const history = useHistory();
  const {
    user: { metadata },
    dataKK,
    dataPK,
    dataKB,
    dataBkkbn,
  } = usePouchDB();
  const [isFetching, setFetching] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { manualSync } = useDataSync();
  const [forms, setForms] = useState([{ type: "wilayah" }]);
  const [formIndex, setFormIndex] = useState(0);
  const [done, setDone] = useState(false);
  const [slide, setSlide] = useState({
    direction: "left",
    in: true,
    navigationMode: "next",
  });

  const [visible, setVisible] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [openTotalTarget, setOpenTotalTarget] = React.useState(false);

  const onDismiss = () => setVisible(false);

  const [isSaved, setSaved] = useState({
    local: false,
    remote: false,
  });

  const [isSubmitting, setSubmitting] = useState({
    local: false,
    remote: false,
  });

  const [wilayah, setWilayah] = useState({});
  const [keluarga, setKeluarga] = useState({});
  // const [pus, setPus] = useState({})
  // const [pusLainnya, setPusLainnya] = useState({})
  const [normalizePus, setNormalizePus] = useState({});
  const [kb, setKB] = useState({});
  const [normalizeKB, setNormalizeKB] = useState("");
  const [pk, setPK] = useState({});
  const [normalizePK, setNormalizePK] = useState({});
  const [targetkk, setTragetKK] = useState(0);
  const [totalDataKKAll, setTotalDataKKAll] = useState(0);
  const [docKK, setDocKK] = useState({});

  // const [hamilPertamaLainnya, setHamilPertamaLainnya] = useState('');
  // const [pertanyaanPus, setPertanyaanPus] = useState('');
  // const [jmlHamilLainnya, setJmlHamilLainnya] = useState('');
  const [locationUser, setLocationUser] = useState([]);
  const [lockWilayah, setLockWilayah] = useState(
    localStorage.getItem("lockWilayah")
  );
  const [lockTarget, setLockTarget] = useState(
    localStorage.getItem("lockTarget")
  );

  const fillForm = async (didCancel) => {
    setFetching(true);

    // let id = params._id + metadata.name
    let id = params._id;
    //

    // let dataRetrievePkJson = localStorage.getItem("retrievePk");
    // let dataRetrievePk = JSON.parse(dataRetrievePkJson);

    // console.log("dataRetrievePkJson", dataRetrievePk);

    try {
      let kkDoc;
      // if (dataRetrievePk && dataRetrievePk.length > 0) {
      //   console.log("dataRetrievePk", dataRetrievePk);

      //   dataRetrievePk = dataRetrievePk.map((data) => {
      //     data["nama_anggotakel"] = data.data_nik[0].nama_anggotakel;
      //     data["nik"] = data.data_nik[0].nik;
      //     return data;
      //   });

      //   // kkDoc = dataRetrievePk.find((el) => el._id === id);
      //   kkDoc = dataRetrievePk;
      //   console.log("dataRetrievePk", kkDoc);
      //   console.log("id params", id);
      // } else {
      kkDoc = await dataBkkbn.local.get(id);
      // console.log("kkDoc dari local", kkDoc);
      // }

      kkDoc = validateNoUrutNik(kkDoc);
      // console.log("kkDoc after validateNoUrutNik", kkDoc);

      if (!didCancel) {
        if (kkDoc) {
          const { data_nik, ...data_bkkbn } = kkDoc;
          // console.log("data nik>>>", data_nik);

          setDocKK({ data_nik, ...data_bkkbn });

          setWilayah(data_bkkbn);
          let newkeluarga = {};
          for (let i = 0; i < data_nik.length; i++) {
            //
            //const id_anggota_kel = ('0' + data_nik[i].no_urutnik).slice(-2);
            const id_anggota_kel = data_nik[i].no_urutnik;
            const currKeluarga = data_nik[i] || {};
            newkeluarga[id_anggota_kel] = {
              ...currKeluarga,
              sts_hubungan: currKeluarga.sts_hubungan
                ? currKeluarga.sts_hubungan.toString()
                : "",
              sts_kawin: currKeluarga.sts_kawin
                ? currKeluarga.sts_kawin.toString()
                : "",
              jns_pendidikan: currKeluarga.jns_pendidikan
                ? currKeluarga.jns_pendidikan.toString()
                : "",
              jns_asuransi: currKeluarga.jns_asuransi
                ? currKeluarga.jns_asuransi.toString()
                : "",
              id_agama: currKeluarga.id_agama
                ? currKeluarga.id_agama.toString()
                : "",
              id_pekerjaan: currKeluarga.id_pekerjaan
                ? currKeluarga.id_pekerjaan.toString()
                : "",
              usia_kawin: currKeluarga.usia_kawin
                ? lodashGet(currKeluarga, "usia_kawin", "").toString()
                : "",
              // sts_hubanak_ibu: currKeluarga.sts_hubanak_ibu ? lodashGet(currKeluarga, 'sts_hubanak_ibu', '').toString() : '',
              kd_ibukandung: currKeluarga.kd_ibukandung
                ? lodashGet(currKeluarga, "kd_ibukandung", "").toString()
                : "0",
              keberadaan: currKeluarga.keberadaan
                ? lodashGet(currKeluarga, "keberadaan", "").toString()
                : "",
              flagNew: false,
            };
          }
          setKeluarga(newkeluarga);
          //

          if (kkDoc.data_kb["0"] !== null) {
            const { data_kb, ...data_bkkbn } = kkDoc;

            setKB(data_bkkbn);
            let newkb = {};

            for (let i = 0; i < data_kb.length; i++) {
              let qid = "";

              if (Object.keys(data_kb[i]).length === 0) {
                let newIndex = i + 1;
                qid = `010${newIndex}`;
              } else {
                if (data_kb[i]._id !== undefined) {
                  let no_tes = parseInt(data_kb[i]._id.length) - 4;
                  qid = `${data_kb[i]._id}`.slice(no_tes);
                }
              }

              //const qid = '0101'

              if (data_kb[i]._id !== undefined) {
                const beauty = beautyKB[qid](data_kb[i]);
                //const beauty = data_kb[i] || {}
                newkb[qid] = {
                  _rev: kkDoc._rev,
                  ...beauty,
                };
              }
            }

            setKB(newkb);
          }

          if (kkDoc.data_pk["0"] !== null) {
            const { data_pk, ...data_bkkbn } = kkDoc;

            setPK(data_bkkbn);
            let newpk = {};
            for (let i = 0; i < data_pk.length; i++) {
              let qid = "";

              if (Array.isArray(kkDoc.data_pk) && kkDoc.data_pk.length > 0) {
                for (let i = 0; i < data_pk.length; i++) {
                  let qid = "";

                  if (data_pk[i] !== undefined) {
                    if (Object.keys(data_pk[i] || {}).length === 0) {
                      let newIndex = i + 1;
                      if (newIndex > 9) {
                        qid = `02${newIndex}`;
                      } else {
                        qid = `020${newIndex}`;
                      }
                    } else {
                      let no_tes = parseInt(data_pk[i]._id?.length) - 4;
                      qid = `${data_pk[i]._id}`.slice(no_tes);
                    }

                    const beauty = beautyPK(qid, data_pk[i]);

                    newpk[qid] = {
                      _rev: kkDoc._rev,
                      ...beauty,
                    };
                  }
                }
              }
            }

            setPK(newpk);
          }
        }

        // setPus(kkDoc.data_pus || [])

        // setPusLainnya(kkDoc.data_pus_lainnya || [])

        // setPertanyaanPus(kkDoc.pertanyaan_pus || '')

        // setHamilPertamaLainnya(kkDoc.hamil_pertama_pus_lainnya || '')

        // setJmlHamilLainnya(kkDoc.jumlah_keluarga_pus_lainnya || '')

        setFetching(false);
      }
    } catch (e) {
      if (!didCancel) {
        enqueueSnackbar("Gagal memuat data: " + e.message, {
          variant: "error",
        });
        // history.push('/')
      }
    }
  };

  const validateNoUrutNik = (kkDoc) => {
    // console.log("ini dari validate", kkDoc);

    kkDoc.data_nik = kkDoc.data_nik.map((el, index) => {
      el.no_urutnik = index + 1;
      return el;
    });
    return kkDoc;
  };

  useEffect(() => {
    if (params._id) {
      let didCancel = false;
      fillForm(didCancel);
      return () => {
        didCancel = true;
      };
    }
  }, [params._id]);

  const handleNextSegmen = (param) => {
    setSlide({
      direction: "right",
      in: false,
      navigationMode: "next",
    });
    setTimeout(() => {
      //
      //
      if (formIndex >= forms.length - 1) {
        setDone(true);
      } else {
        setFormIndex((index) => param);
      }
      setSlide({
        direction: "left",
        in: true,
        navigationMode: "next",
      });
    }, 300);
  };

  const handleBackSegmen = (param) => {
    setSlide({
      direction: "left",
      in: false,
      navigationMode: "back",
    });
    setTimeout(() => {
      setFormIndex((index) => param);
      setSlide({
        direction: "right",
        in: true,
        navigationMode: "back",
      });
    }, 300);
  };

  const handleSegmen = (e, index) => {
    if (e) e.preventDefault();

    if (forms[index]?.type === "wilayah") {
      // Langsung navigasi tanpa validasi apapun
      if (index !== formIndex) {
        if (index < formIndex) {
          handleBackSegmen(index);
        } else {
          handleNextSegmen(index);
        }
      }
      return;
    }

    if (forms[index].type === "kb") {
      let validateKB = segmenKBValidate();
      if (Object.keys(kb).length === 0 && validateKB === true) {
        if (index !== formIndex) {
          if (index < formIndex) {
            handleBackSegmen(index);
          } else {
            handleNextSegmen(index);
          }
        }
        return;
      } else if (validateKB === false) {
        return;
      }
    }

    if (forms[index].type === "pk") {
      let validatePK = segmenPKValidate();
      if (validatePK === false) {
        return;
      }
    }
    if (index !== formIndex) {
      if (index < formIndex) {
        handleBackSegmen(index);
      } else {
        handleNextSegmen(index);
      }
    }
  };

  //

  const segmenKBValidate = () => {
    let newValidate = true;
    let message = "";

    // Validasi form KB No.4
    //harus kosong
    // if (Object.keys(kb).length) {
    //   if (kb["0103"].sedang_hamil === "1") {
    //     if (kb["0104"].menggunakan_kontrasepsi !== undefined) {
    //       newValidate = false;
    //       message = `KB No.4 Harus Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }

    //   //tidak boleh kosong
    //   if (kb["0103"].sedang_hamil !== "1") {
    //     if (kb["0104"].menggunakan_kontrasepsi === undefined) {
    //       newValidate = false;
    //       message = `KB No.4 Tidak Boleh Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }
    //   // end Validasi form KB No.4

    //   // Validasi form KB No.5
    //   // harus kosong
    //   if (
    //     kb["0103"].sedang_hamil === "2" &&
    //     kb["0104"].menggunakan_kontrasepsi === "1"
    //   ) {
    //     if (kb["0105"].pernah_menggunakan_kontrasepsi !== undefined) {
    //       newValidate = false;
    //       message = `KB No.5 Harus Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }

    //   //tidak boleh kosong
    //   if (
    //     kb["0103"].sedang_hamil !== "2" &&
    //     kb["0104"].menggunakan_kontrasepsi !== "1"
    //   ) {
    //     if (kb["0105"].pernah_menggunakan_kontrasepsi === undefined) {
    //       newValidate = false;
    //       message = `KB No.5 Tidak Boleh Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }
    //   // end Validasi form KB No.5

    //   // Validasi form KB No.6
    //   //harus kosong
    //   if (
    //     kb["0103"].sedang_hamil === "2" &&
    //     kb["0104"].menggunakan_kontrasepsi === "1"
    //   ) {
    //     if (kb["0106"].alasan_tidak_kb !== undefined) {
    //       newValidate = false;
    //       message = `KB No.6 Harus Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }

    //   //tidak boleh kosong
    //   if (
    //     kb["0103"].sedang_hamil !== "2" &&
    //     kb["0104"].menggunakan_kontrasepsi !== "1"
    //   ) {
    //     if (kb["0106"].alasan_tidak_kb === undefined) {
    //       newValidate = false;
    //       message = `KB No.6 Tidak Boleh Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }
    //   // end Validasi form KB No.6

    //   // Validasi form KB No.7
    //   // harus kosong
    //   if (
    //     kb["0103"].sedang_hamil === "1" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi === "2"
    //   ) {
    //     if (kb["0107"].jenis_kontrasepsi !== undefined) {
    //       newValidate = false;
    //       message = `KB No.7 Harus Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   } else if (
    //     kb["0103"].sedang_hamil === "2" &&
    //     kb["0104"].menggunakan_kontrasepsi === "2" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi === "2"
    //   ) {
    //     if (kb["0107"].jenis_kontrasepsi !== undefined) {
    //       newValidate = false;
    //       message = `KB No.7 Harus Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }

    //   //tidak bioleh kosong
    //   if (
    //     kb["0103"].sedang_hamil !== "1" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi !== "2"
    //   ) {
    //     if (kb["0107"].jenis_kontrasepsi === undefined) {
    //       newValidate = false;
    //       message = `KB No.7 Tidak Boleh Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   } else if (
    //     kb["0103"].sedang_hamil !== "2" &&
    //     kb["0104"].menggunakan_kontrasepsi !== "2" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi !== "2"
    //   ) {
    //     if (kb["0107"].jenis_kontrasepsi === undefined) {
    //       newValidate = false;
    //       message = `KB No.7 Tidak Boleh Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }
    //   // end Validasi form KB No.7

    //   // Validasi form KB No.8
    //   //harus kosong
    //   if (kb["0107"].jenis_kontrasepsi === "9") {
    //     if (kb["0108"].tempat_pelayanan !== undefined) {
    //       newValidate = false;
    //       message = `KB No.8 Harus Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   } else if (
    //     kb["0103"].sedang_hamil === "1" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi === "2"
    //   ) {
    //     if (kb["0108"].tempat_pelayanan !== undefined) {
    //       newValidate = false;
    //       message = `KB No.8 Harus Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   } else if (
    //     kb["0103"].sedang_hamil === "2" &&
    //     kb["0104"].menggunakan_kontrasepsi === "2" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi === "2"
    //   ) {
    //     if (kb["0108"].tempat_pelayanan !== undefined) {
    //       newValidate = false;
    //       message = `KB No.8 Harus Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }
    //   //end

    //   //tidak boleh kosong
    //   if (
    //     kb["0103"].sedang_hamil !== "2" &&
    //     kb["0104"].menggunakan_kontrasepsi !== "2" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi !== "2" &&
    //     kb["0107"].jenis_kontrasepsi !== "9"
    //   ) {
    //     if (kb["0108"].tempat_pelayanan === undefined) {
    //       newValidate = false;
    //       message = `KB No.8 Tidak Boleh Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   } else if (
    //     kb["0103"].sedang_hamil !== "1" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi !== "2"
    //   ) {
    //     if (kb["0108"].tempat_pelayanan === undefined) {
    //       newValidate = false;
    //       message = `KB No.8 Tidak Boleh Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   } else if (
    //     kb["0103"].sedang_hamil !== "2" &&
    //     kb["0104"].menggunakan_kontrasepsi !== "2" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi !== "2"
    //   ) {
    //     if (kb["0108"].tempat_pelayanan === undefined) {
    //       newValidate = false;
    //       message = `KB No.8 Tidak Boleh Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }
    //   //end
    //   // end Validasi form KB No.8

    //   // Validasi form KB No.9
    //   //harus kosong
    //   if (kb["0107"].jenis_kontrasepsi === "9") {
    //     if (kb["0109"].info_jenis_kb !== undefined) {
    //       newValidate = false;
    //       message = `KB No.9 Harus Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   } else if (
    //     kb["0103"].sedang_hamil === "1" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi === "2"
    //   ) {
    //     if (kb["0109"].info_jenis_kb !== undefined) {
    //       newValidate = false;
    //       message = `KB No.9 Harus Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   } else if (
    //     kb["0103"].sedang_hamil === "2" &&
    //     kb["0104"].menggunakan_kontrasepsi === "2" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi === "2"
    //   ) {
    //     if (kb["0109"].info_jenis_kb !== undefined) {
    //       newValidate = false;
    //       message = `KB No.9 Harus Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }

    //   //tidak boleh kosong
    //   if (
    //     kb["0103"].sedang_hamil !== "2" &&
    //     kb["0104"].menggunakan_kontrasepsi !== "2" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi !== "2" &&
    //     kb["0107"].jenis_kontrasepsi !== "9"
    //   ) {
    //     if (kb["0109"].info_jenis_kb === undefined) {
    //       newValidate = false;
    //       message = `KB No.9 Tidak Boleh Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   } else if (
    //     kb["0103"].sedang_hamil !== "1" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi !== "2"
    //   ) {
    //     if (kb["0109"].info_jenis_kb === undefined) {
    //       newValidate = false;
    //       message = `KB No.9 Tidak Boleh Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   } else if (
    //     kb["0103"].sedang_hamil !== "2" &&
    //     kb["0104"].menggunakan_kontrasepsi !== "2" &&
    //     kb["0105"].pernah_menggunakan_kontrasepsi !== "2"
    //   ) {
    //     if (kb["0109"].info_jenis_kb !== undefined) {
    //       newValidate = false;
    //       message = `KB No.9 Tidak Boleh Kosong`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //     }
    //   }
    // }

    // end Validasi form KB No.9

    // if (newValidate == false) {
    //     enqueueSnackbar(message, { variant: "warning" })
    // }

    return newValidate;
  };

  const segmenPKValidate = () => {
    let newValidate = true;
    let message = "";

    let total = Object.keys(keluarga);

    let enam = false;
    let tujuh = false;
    let sepuluhdualima = false;
    let enampuluh = false;

    if (wilayah.status_draft !== 1) {
      for (let i = 1; i <= total.length; i++) {
        let umur = ageConvert(keluarga[i].tgl_lahir);

        if (umur < 6) {
          enam = true;
        }

        if (umur < 7) {
          tujuh = true;
        }

        if (umur >= 10 && umur <= 24) {
          if (keluarga[i].sts_hubungan === "3") {
            sepuluhdualima = true;
          }
        }

        if (umur >= 60) {
          enampuluh = true;
        }
      }
      //

      // Validasi PK No.02
      // if (pk["0202"]) {
      //   if (keluarga[1].sts_kawin === 2) {
      //     if (pk["0202"].jawaban === 3) {
      //       //
      //       newValidate = false;
      //       message = `PK No.02 Harus Dirubah`;
      //       enqueueSnackbar(message, { variant: "Error" });
      //       return newValidate;
      //     }
      //   }

      //   if (keluarga[1].sts_kawin !== 2) {
      //     if (pk["0202"].jawaban !== undefined) {
      //       if (pk["0202"].jawaban !== 3) {
      //         //
      //         newValidate = false;
      //         message = `PK No.02 Harus Dirubah`;
      //         enqueueSnackbar(message, { variant: "Error" });
      //         return newValidate;
      //       }
      //     }
      //   }
      // }

      if (wilayah.jumlah_keluarga > 1) {
        if (pk["0203"]) {
          if (pk["0203"].jawabanA === undefined) {
            newValidate = false;
            message = `PK No.03 Harus Dirubah`;
            enqueueSnackbar(message, { variant: "Error" });
            return newValidate;
          }
        }

        // if (pk["0209"]) {
        //   if (pk["0209"].jawaban === undefined) {
        //     newValidate = false;
        //     message = `PK No.09 Harus Dirubah`;
        //     enqueueSnackbar(message, { variant: "Error" });
        //     return newValidate;
        //   }
        // }

        // if (pk["0211"]) {
        //   if (pk["0211"].jawaban === undefined) {
        //     newValidate = false;
        //     message = `PK No.11 Harus Dirubah`;
        //     enqueueSnackbar(message, { variant: "Error" });
        //     return newValidate;
        //   }
        // }
      }

      // if (enam) {
      //     if (pk["0213"]) {
      //         if(pk["0213"].jawaban == 3 || pk["0213"].jawaban == undefined) {
      //             newValidate = false
      //             message = `PK No.13 = Tidak Berlaku, Harus Dirubah`
      //             enqueueSnackbar(message, { variant: "Error" })
      //             return newValidate

      //         }
      //     }
      // } else {
      //     if (pk["0213"]) {
      //         if(pk["0213"].jawaban != undefined && pk["0213"].jawaban != 3) {
      //             newValidate = false
      //             message = `PK No.13 Harus Dirubah`
      //             enqueueSnackbar(message, { variant: "Error" })
      //             return newValidate

      //         }
      //     }
      // }

      // if (tujuh) {
      //     if (pk["0214"]) {
      //         if (pk["0214"].jawaban == 3 || pk["0214"].jawaban == undefined) {
      //             newValidate = false
      //             message = `PK No.14 = Tidak Berlaku, Harus Dirubah`
      //             enqueueSnackbar(message, { variant: "Error" })
      //             return newValidate

      //         }
      //     }
      // } else {
      //     if (pk["0214"]) {
      //         if (pk["0214"].jawaban != undefined && pk["0214"].jawaban != 3) {
      //             newValidate = false
      //             message = `PK No.14 Harus Dirubah`
      //             enqueueSnackbar(message, { variant: "Error" })
      //             return newValidate
      //         }
      //     }
      // }

      // if (sepuluhdualima) {
      //     if(pk["0215"] && pk["0216"]){
      //         if(pk["0215"].jawaban == 3 && pk["0216"].jawaban == 3 || pk["0215"].jawaban == undefined && pk["0216"].jawaban == undefined) {
      //             newValidate = false
      //             message = `PK No.15 Atau PK No.16 = Tidak Berlaku, Harus Dirubah`
      //             enqueueSnackbar(message, { variant: "Error" })
      //             return newValidate

      //         }
      //     }
      // } else {
      //     if(pk["0215"] && pk["0216"]){
      //         if(pk["0215"].jawaban != undefined && pk["0215"].jawaban != 3 && pk["0216"].jawaban != undefined && pk["0216"].jawaban != 3) {
      //             newValidate = false
      //             message = `PK No.15 Atau PK No.16 Harus Dirubah`
      //             enqueueSnackbar(message, { variant: "Error" })
      //             return newValidate

      //         }
      //     }
      // }

      // if (enampuluh) {
      //     if(pk["0217"]){
      //         if(pk["0217"].jawaban == 3 || pk["0217"].jawaban == undefined) {
      //             newValidate = false
      //             message = `PK No.17 = Tidak Berlaku, Harus Dirubah`
      //             enqueueSnackbar(message, { variant: "Error" })
      //             return newValidate

      //         }
      //     }
      // } else {
      //     if(pk["0217"]){
      //         if(pk["0217"].jawaban != undefined && pk["0217"].jawaban != 3) {
      //             newValidate = false
      //             message = `PK No.17 Harus Dirubah`
      //             enqueueSnackbar(message, { variant: "Error" })
      //             return newValidate
      //         }
      //     }
      // }
      // end Validasi PK No.13 sampai 17

      // Validasi PK No.26 done
      if (pk["0226"]) {
        if (pk["0226"].jawaban === "2") {
          if (pk["0227"]) {
            if (pk["0227"].jawaban !== undefined) {
              //

              newValidate = false;
              message = `PK No.27 Harus Kosong`;
              enqueueSnackbar(message, { variant: "Error" });
              return newValidate;
            }
          }
        }
      }
    }
  };

  function countAgeMonth(tgl_lahir) {
    const days = differenceInCalendarDays(
      new Date(),
      parseDate(tgl_lahir, formatString, new Date())
    );

    const month = days / 30.41;
    return parseInt(month);
  }

  const ageConvert = (tgl_lahir) => {
    const month = countAgeMonth(tgl_lahir); //days / 365;
    let umur = month / 12;

    // if (month > 720)
    return umur;
  };

  const checkPosDraft = (jml_kel, val) => {
    if (val) {
      const x = parseInt(jml_kel);
      if (val) {
        if (x > 1) {
          val > 1 ? (val = val + x - 1) : (val = val);
        }
        if (x === 1 && val === 2) {
          //
          // alert("Data KB tidak tersedia");
        } else {
          //
          handleSegmen(null, val);
        }
      }
    }
  };

  //

  useEffect(() => {
    if (wilayah.jumlah_keluarga) {
      const jumlah_keluarga = parseInt(wilayah.jumlah_keluarga);
      //
      setKeluarga((keluarga) => {
        //
        let newkeluarga = {};
        for (let i = 1; i <= jumlah_keluarga; i++) {
          //const id_anggota_kel = ('0' + i).slice(-2);
          const id_anggota_kel = i;
          const currKeluarga = keluarga[id_anggota_kel] || {};
          newkeluarga[id_anggota_kel] = {
            no_urutnik: i,
            ...currKeluarga,
            flagNew: Object.keys(currKeluarga).length > 0 ? false : true,
          };
        }

        //
        setForms([
          { type: "wilayah" },
          ...Object.keys(newkeluarga).map((key) => ({
            type: "keluarga",
            id: key,
          })),
          { type: "kb" },
          { type: "pk" },
          // { type: 'pertanyaan'},
          // { type: 'pus' },
          // { type: 'hamilLainnya'},
          // { type: 'pusLainnya' },
        ]);

        return newkeluarga;
      });
    }
  }, [wilayah.jumlah_keluarga]);

  useEffect(() => {
    if (
      wilayah &&
      wilayah.pos_draft &&
      wilayah.jumlah_keluarga &&
      forms.length >= 4
    ) {
      //fix save after handledraft
      if (
        wilayah.status_draft === 2 &&
        wilayah.pos_draft !== 0 &&
        wilayah.subformIndex !== 0
      ) {
        checkPosDraft(wilayah.jumlah_keluarga, wilayah.pos_draft);
      }

      //handledraft action
      if (wilayah.status_draft === 1) {
        //
        checkPosDraft(wilayah.jumlah_keluarga, wilayah.pos_draft);
      }
    }

    //if notvalid action
    if (wilayah.status_draft === 2 && wilayah.status_sensus === "NotValid") {
      const form_invalid = wilayah.form_invalid;
      if (form_invalid !== "") {
        if (form_invalid === "kb") {
          checkPosDraft(wilayah.jumlah_keluarga, 2);
        } else if (form_invalid === "pk") {
          checkPosDraft(wilayah.jumlah_keluarga, 3);
        }
      }
    }
  }, [forms]);

  if (isFetching) {
    return <AppPageLoading />;
  }

  const resetForm = () => {
    history.push("/form");
    // setSlide({
    //     direction: "right",
    //     in: false,
    //     navigationMode: "next"
    // });
    // setTimeout(() => {
    //     setForms([{ type: 'wilayah' }]);
    //     setFormIndex(0);
    //     setSlide({
    //         direction: "left",
    //         in: true,
    //         navigationMode: "next"
    //     })
    //     setWilayah({})
    //     setKeluarga({})
    //     setKB({})
    //     setNormalizeKB({})
    //     setPK({})
    //     setNormalizePK({})

    //     setDone(false);
    // }, 300)
  };

  const updateNotif = (id) => {
    let userUpdate = metadata.name;
    let userDataUpdate = 8;

    fetch("https://webpushnotif-dev.bkkbn.go.id/api/v1/pushnotification", {
      // fetch('https://webpushnotif.bkkbn.go.id/api/v1/pushnotification', {
      // fetch('http://dev-web-push-notification-service-bkkbn.apps.tkp.platform.lintasarta.net/api/v1/pushnotification', {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({
        _id: id,
        username: userUpdate,
        statusData: userDataUpdate,
      }),
    })
      .then((respone) => {
        respone.json();
      })
      .then((data) => {})
      .catch((e) => console.error(e));
  };

  const clearForm = () => {
    setWilayah({});
    setKeluarga({});
    setKB({});
    setNormalizeKB({});
    setPK({});
    setNormalizePK({});
    history.push("/");
  };

  const handleNext = () => {
    if (
      +wilayah.sts_keluarga === 2 ||
      +wilayah.sts_keluarga === 3 ||
      +wilayah.sts_keluarga === 4
    ) {
      setDone(true);
      // (async () => {
      //     enqueueSnackbar('Proses Simpan Data...', { variant: "info" })
      //
      //     const target = 'remote'
      //     // put data utama to KK
      //     let create_id = `${Date.now().toString()}${metadata.name}`

      //     const dataKKUtama = {
      //         // _id: wilayah.no_kk,
      //         _id: create_id,
      //         user_name: metadata.name,
      //         id_prov: parseInt(metadata.wil_provinsi.id_provinsi),
      //         id_prov_depdagri: parseInt(metadata.wil_provinsi.id_provinsi_depdagri),
      //         id_kab: parseInt(metadata.wil_kabupaten.id_kabupaten),
      //         id_kab_depdagri: parseInt(metadata.wil_kabupaten.id_kabupaten_depdagri),
      //         id_kec: parseInt(metadata.wil_kecamatan.id_kecamatan),
      //         id_kec_depdagri: parseInt(metadata.wil_kecamatan.id_kecamatan_depdagri),
      //         id_kel: parseInt(metadata.wil_kelurahan.id_kelurahan),
      //         id_kel_depdagri: parseInt(metadata.wil_kelurahan.id_kelurahan_depdagri),
      //         ...wilayah,
      //         id_rw: wilayah.id_rw,
      //         id_rt: wilayah.id_rt,
      //         id_rw_bkkbn: wilayah.id_rw_bkkbn,
      //         id_rt_bkkbn: wilayah.id_rt_bkkbn,
      //         location: { locationUser },
      //     };

      //     const data_nik = Object.keys(keluarga).map(_id => {

      //         return {
      //             ...keluarga[_id],
      //             sts_hubungan: parseInt(keluarga[_id].sts_hubungan),
      //             sts_kawin: parseInt(keluarga[_id].sts_kawin),
      //             jns_pendidikan: parseInt(keluarga[_id].jns_pendidikan),
      //             jns_asuransi: parseInt(keluarga[_id].jns_asuransi),
      //             id_agama: parseInt(keluarga[_id].id_agama),
      //             // id_pekerjaan: parseInt(keluarga[_id].id_pekerjaan),
      //             usia_kawin: parseInt(keluarga[_id].sts_kawin) === 1 ? 0 : parseInt(lodashGet(keluarga[_id], 'usia_kawin', 0)),
      //             // sts_hubanak_ibu: parseInt(lodashGet(keluarga[_id], 'sts_hubanak_ibu', 0)),
      //             kd_ibukandung: parseInt(lodashGet(keluarga[_id], 'kd_ibukandung', 0)),
      //             umur: countAge(keluarga[_id].tgl_lahir),
      //             // keberadaan: parseInt(lodashGet(keluarga[_id], 'keberadaan', 0)),
      //         }
      //     })
      //     //simpan ke db local
      //     setSubmitting(curr => ({ ...curr, [target]: true }));

      //     let data_pk = Object.values(normalizePK);
      //     let data_kb = Object.values(normalizeKB);
      //     // let data_pus = []
      //     // let data_pus_lainnya = []
      //     // let hamil_pertama_pus_lainnya = ''
      //     // let jumlah_keluarga_pus_lainnya = ''
      //     const findWife = Object.values(keluarga).find(k => {
      //         if (k.jenis_kelamin === "2" && k.sts_kawin === "2" && k.sts_hubungan === "2") {
      //             const age = countAge(k.tgl_lahir);
      //             return age >= 10 && age <= 49;
      //         }
      //         return false;
      //     })

      //     if (Object.values(normalizePK).length == 0) {
      //         data_pk = wilayah.data_pk
      //     }

      //     // if (pertanyaanPus == "1") {
      //     //     //Istri hamil atau memiliki anak
      //     //     if (Object.values(pus).length > 0) {
      //     //         data_pus = Object.values(pus);
      //     //     }

      //     //     if (hamilPertamaLainnya == "1") {
      //     //         data_pus_lainnya = Object.values(pusLainnya);
      //     //     }

      //     //     hamil_pertama_pus_lainnya = hamilPertamaLainnya
      //     //     jumlah_keluarga_pus_lainnya = jmlHamilLainnya
      //     // }

      //     if (keluarga['1'].sts_kawin == '2') {
      //         //jika dia memiliki istri
      //         if (findWife) {
      //             if (normalizeKB == '') {
      //                 data_kb = wilayah.data_kb
      //             }
      //         } else {
      //             data_kb = Object.values('')
      //         }

      //     } else {
      //         data_kb = Object.values('')
      //     }

      //     // const data_kb = Object.values(normalizeKB);
      //     //const data_pk = Object.values(normalizePK);
      //     const status_draft = '2';
      //     const pos_draft = ''
      //     const subformIndex = '0'
      //     const form_invalid = ''
      //     const index_invalid = ''
      //     // const pertanyaan_pus = pertanyaanPus
      //     const created = Date.now()
      //     const last_update = Date.now()
      //     // for audit_trail
      //     let os = window.navigator.userAgent //get Browser and Os Version
      //     let time = new Date().toLocaleString().replace(",", "").replace(/:.. /, " ")

      //     //

      //     //perubahan baru
      //     let dataBkkbnAll = {
      //         ...dataKKUtama,
      //         periode_sensus: "2022",
      //         status_sensus: "",
      //         group: 'dataBkkbn',
      //         data_nik,
      //         data_kb,
      //         data_pk,
      //         // pertanyaan_pus,
      //         // hamil_pertama_pus_lainnya,
      //         // jumlah_keluarga_pus_lainnya,
      //         // data_pus,
      //         // data_pus_lainnya,
      //         status_draft,
      //         pos_draft,
      //         subformIndex,
      //         last_update,
      //         form_invalid,
      //         index_invalid
      //     }

      //     let dataToSave = { ...dataBkkbnAll }
      //     let dataToSaveLocal

      //     try {

      //         const kkDoc = await dataBkkbn.remote.get(wilayah._id);

      //         const audit_trail = "Update From " + os + " At " + time

      //         dataToSave = {
      //             ...dataBkkbnAll,
      //             audit_trail,
      //             _rev: kkDoc._rev
      //         }

      //         dataToSaveLocal = {
      //             ...dataBkkbnAll,
      //             audit_trail,
      //             status_sensus: "Tersimpan"
      //         }

      //         await dataBkkbn[target].put(dataToSave);

      //         await dataBkkbn['local'].put(dataToSaveLocal);

      //         manualSync()

      //         let message = `Data berhasil diperbarui`
      //         enqueueSnackbar(message, { variant: "success" })

      //         const id = wilayah._id;

      //         setSubmitting(curr => ({ ...curr, [target]: false }));
      //         setSaved(curr => ({ ...curr, [target]: true }));
      //         updateNotif(id);
      //         clearForm()

      //     } catch (e) {

      //         dataToSaveLocal = {
      //             ...dataBkkbnAll,
      //             status_sensus: "",
      //         }
      //         //end
      //

      //         try {
      //             await dataBkkbn['local'].put(dataToSaveLocal);
      //         } catch (error) {
      //
      //         }

      //         let message = `Data berhasil diperbarui`
      //         enqueueSnackbar(message, { variant: "success" })

      //         setSubmitting(curr => ({ ...curr, [target]: false }));
      //         setSaved(curr => ({ ...curr, [target]: true }));
      //         //enqueueSnackbar(e.message, { variant: 'error' })
      //         if (e.message.includes("The database connection is closing")) {
      //             window.location.href = "/login"
      //         }
      //     }
      // })();
    } else {
      setSlide({
        direction: "right",
        in: false,
        navigationMode: "next",
      });
      setTimeout(() => {
        if (formIndex === 0) {
          setFormIndex((index) => index + 1);
        } else {
          if (formIndex >= forms.length - 1) {
            //
            setDone(true);
          } else {
            setFormIndex((index) => index + 1);
          }
        }
        setSlide({
          direction: "left",
          in: true,
          navigationMode: "next",
        });
      }, 300);
    }
  };

  const handleBack = (param) => {
    if (param === "WAW") {
      setSlide({
        direction: "left",
        in: false,
        navigationMode: "back",
      });
      setTimeout(() => {
        setFormIndex((index) => 0);
        setSlide({
          direction: "right",
          in: true,
          navigationMode: "back",
        });
      }, 300);
    } else {
      setSlide({
        direction: "left",
        in: false,
        navigationMode: "back",
      });
      setTimeout(() => {
        setFormIndex((index) => index - 1);
        setSlide({
          direction: "right",
          in: true,
          navigationMode: "back",
        });
      }, 300);
    }
  };

  if (done) {
    return (
      <>
        <Slide direction={slide.direction} in={slide.in}>
          <div>
            <Finish
              wilayah={wilayah}
              keluarga={keluarga}
              // pus={pus}
              // pusLainnya={pusLainnya}
              kb={kb}
              normalizePK={normalizePK}
              normalizeKB={normalizeKB}
              // pertanyaanPus={pertanyaanPus}
              // hamilPertamaLainnya={hamilPertamaLainnya}
              // jmlHamilLainnya={jmlHamilLainnya}
              resetForm={resetForm}
              mode="edit"
              no_kk={params.no_kk}
              // pk={pk}
              // kb={kb}
            />
          </div>
        </Slide>
      </>
    );
  }

  const f = forms[formIndex];

  //

  //
  //
  //
  //

  const handleAnomali = (target, form) => async (e) => {
    //
    var alert = window.confirm(
      "Apakah anda yakin untuk mengkonfirmasi data Anomali ini ?"
    );
    if (alert === true) {
      //

      // put data utama to KK
      const dataKKUtama = {
        // _id: wilayah.no_kk,
        _id: `${Date.now().toString()}${metadata.name}`,
        user_name: metadata.name,
        id_prov: parseInt(metadata.wil_provinsi.id_provinsi),
        id_prov_depdagri: parseInt(metadata.wil_provinsi.id_provinsi_depdagri),
        id_kab: parseInt(metadata.wil_kabupaten.id_kabupaten),
        id_kab_depdagri: parseInt(metadata.wil_kabupaten.id_kabupaten_depdagri),
        id_kec: parseInt(metadata.wil_kecamatan.id_kecamatan),
        id_kec_depdagri: parseInt(metadata.wil_kecamatan.id_kecamatan_depdagri),
        id_kel: parseInt(metadata.wil_kelurahan.id_kelurahan),
        id_kel_depdagri: parseInt(metadata.wil_kelurahan.id_kelurahan_depdagri),
        ...wilayah,
        id_rw: wilayah.id_rw,
        id_rt: wilayah.id_rt,
        id_rw_bkkbn: wilayah.id_rw_bkkbn,
        id_rt_bkkbn: wilayah.id_rt_bkkbn,
        klasifikasi_desa: metadata.wil_kelurahan.klasifikasiDesa || "",
        lokus_verval_pk25: metadata.wil_kelurahan.lokus_verval_pk25 || "",
        cfm: wilayah.cfm,
        location: { locationUser },
      };
      const data_nik = Object.keys(keluarga).map((_id) => {
        return {
          ...keluarga[_id],
          sts_hubungan: parseInt(keluarga[_id].sts_hubungan),
          sts_kawin: parseInt(keluarga[_id].sts_kawin),
          jns_pendidikan: parseInt(keluarga[_id].jns_pendidikan),
          jns_asuransi: parseInt(keluarga[_id].jns_asuransi),
          id_agama: parseInt(keluarga[_id].id_agama),
          id_pekerjaan: parseInt(keluarga[_id].id_pekerjaan),
          usia_kawin:
            parseInt(keluarga[_id].sts_kawin) === 1
              ? 0
              : parseInt(lodashGet(keluarga[_id], "usia_kawin", 0)),
          // sts_hubanak_ibu: parseInt(lodashGet(keluarga[_id], 'sts_hubanak_ibu', 0)),
          kd_ibukandung: parseInt(lodashGet(keluarga[_id], "kd_ibukandung", 0)),
          umur: countAge(keluarga[_id].tgl_lahir),
          keberadaan: parseInt(lodashGet(keluarga[_id], "keberadaan", 0)),
        };
      });
      //simpan ke db local
      setSubmitting((curr) => ({ ...curr, [target]: true }));
      try {
        const data_kb = wilayah.data_kb;
        const data_pk = wilayah.data_pk;
        // const pertanyaan_pus = wilayah.pertanyaan_pus;
        // const data_pus = wilayah.data_pus;
        // const data_pus_lainnya = wilayah.data_pus_lainnya;
        // const hamil_pertama_pus_lainnya = wilayah.hamil_pertama_pus_lainnya
        // const jumlah_keluarga_pus_lainnya = wilayah.jumlah_keluarga_pus_lainnya
        const status_draft = "2";

        let os = window.navigator.userAgent; //get Browser and Os Version
        let time = new Date()
          .toLocaleString()
          .replace(",", "")
          .replace(/:.. /, " ");
        const audit_trail = "Anomali Confirmations " + os + " At " + time;

        // const kkDocRemote = await dataBkkbn.remote.get(wilayah._id);
        const data_selector = {
          selector: {
            _id: wilayah._id,
          },
          limit: 10000,
        };
        const idkec = metadata?.wil_kecamatan?.id_kecamatan;
        let kkDocRemote = await axios.post(
          url +
            "/_find?couchdb=" +
            couchdb +
            "&database-name=" +
            db_name +
            "&idKec=" +
            idkec,
          data_selector,
          {
            // headers: { user_key: USER_KEY_PG }
            headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
          }
        );

        const dataBkkbnAll = {
          ...dataKKUtama,
          status_sensus: "Anomali Terkonfirmasi",
          group: "dataBkkbn",
          data_nik,
          data_kb,
          data_pk,
          // pertanyaan_pus,
          // hamil_pertama_pus_lainnya,
          // jumlah_keluarga_pus_lainnya,
          // data_pus,
          // data_pus_lainnya,
          status_draft,
          audit_trail,
          _rev: kkDocRemote.data[0]._rev,
        };

        // await dataBkkbn['remote'].put(dataBkkbnAll);
        await axios.put(
          url +
            "/" +
            dataBkkbnAll._id +
            "/_put?couchdb=" +
            couchdb +
            "&database-name=" +
            db_name +
            "&_id=" +
            dataBkkbnAll._id +
            "&idKec=" +
            metadata?.wil_kecamatan?.id_kecamatan,
          dataBkkbnAll,
          {
            // headers: { user_key: USER_KEY_PG }
            headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
          }
        );

        console.log("dataBkkbnAll", dataBkkbnAll);

        let message =
          mode === "edit"
            ? `Data Anomali berhasil diperbarui`
            : `Data berhasil disimpan silahkan melakukan sync`;
        enqueueSnackbar(message, { variant: "success" });

        const id = wilayah._id;

        // setSubmitting(curr => ({ ...curr, [target]: false }));
        setSaved((curr) => ({ ...curr, [target]: true }));

        //
        history.push("/list");
      } catch (e) {
        // setSubmitting(curr => ({ ...curr, [target]: false }));
        enqueueSnackbar("Silahkan Online Untuk Melakukan Konfirmasi", {
          variant: "warning",
        });
        if (e.message.includes("The database connection is closing")) {
          window.location.href = "/login";
        }
      }
    } else {
    }
  };

  const handleClose = () => {
    setOpen(false);
    setOpenTotalTarget(false);
  };

  const handleDraft = (target, form, indexForm) => async (e) => {
    //
    // console.log("handleDraft edit", target, form, indexForm);
    // console.log("normalizePK", normalizePK);

    if (lockWilayah === "true") {
      setOpen(true);
      // } else if (lockTarget === 'true' || targetkk >= totalDataKKAll) {
      //
      //     setOpenTotalTarget(true)
      // } else if (targetkk === 0) {
      //
      //     setOpenTotalTarget(true)
    } else {
      var alert = window.confirm(
        "Apakah anda yakin untuk menyimpan data sementara ke Draft ?\nAnda akan diarahkan ke Daftar Draft"
      );
      if (alert === true) {
        //

        //
        //

        // put data utama to KK
        const dataKKUtama = {
          // _id: wilayah.no_kk,
          _id: `${Date.now().toString()}${metadata.name}`,
          user_name: metadata.name,
          id_prov: parseInt(metadata.wil_provinsi.id_provinsi),
          id_prov_depdagri: parseInt(
            metadata.wil_provinsi.id_provinsi_depdagri
          ),
          id_kab: parseInt(metadata.wil_kabupaten.id_kabupaten),
          id_kab_depdagri: parseInt(
            metadata.wil_kabupaten.id_kabupaten_depdagri
          ),
          id_kec: parseInt(metadata.wil_kecamatan.id_kecamatan),
          id_kec_depdagri: parseInt(
            metadata.wil_kecamatan.id_kecamatan_depdagri
          ),
          id_kel: parseInt(metadata.wil_kelurahan.id_kelurahan),
          id_kel_depdagri: parseInt(
            metadata.wil_kelurahan.id_kelurahan_depdagri
          ),
          ...wilayah,
          id_rw: wilayah.id_rw,
          id_rt: wilayah.id_rt,
          id_rw_bkkbn: wilayah.id_rw_bkkbn,
          id_rt_bkkbn: wilayah.id_rt_bkkbn,
          location: { locationUser },
        };
        const data_nik = Object.keys(keluarga).map((_id) => {
          return {
            ...keluarga[_id],
            sts_hubungan: parseInt(keluarga[_id].sts_hubungan),
            sts_kawin: parseInt(keluarga[_id].sts_kawin),
            jns_pendidikan: parseInt(keluarga[_id].jns_pendidikan),
            jns_asuransi: parseInt(keluarga[_id].jns_asuransi),
            id_agama: parseInt(keluarga[_id].id_agama),
            id_pekerjaan: parseInt(keluarga[_id].id_pekerjaan),
            usia_kawin:
              parseInt(keluarga[_id].sts_kawin) === 1
                ? 0
                : parseInt(lodashGet(keluarga[_id], "usia_kawin", 0)),
            // sts_hubanak_ibu: parseInt(lodashGet(keluarga[_id], 'sts_hubanak_ibu', 0)),
            kd_ibukandung: parseInt(
              lodashGet(keluarga[_id], "kd_ibukandung", 0)
            ),
            umur: countAge(keluarga[_id].tgl_lahir),
            keberadaan: parseInt(lodashGet(keluarga[_id], "keberadaan", 0)),
          };
        });
        //simpan ke db local
        setSubmitting((curr) => ({ ...curr, [target]: true }));

        let data_kb;
        let data_pk;

        // let data_pus
        // let data_pus_lainnya
        if (wilayah.status_draft === 1) {
          if (wilayah.data_kb === undefined) {
            data_kb = Object.values(normalizeKB);
          } else {
            if (normalizeKB === "") {
              data_kb = wilayah.data_kb;
            } else {
              data_kb = Object.values(normalizeKB);
            }
          }

          if (wilayah.data_pk === undefined) {
            data_pk = Object.values(normalizePK);
          } else {
            if (Object.values(normalizePK).length === 0) {
              data_pk = wilayah.data_pk;
            } else {
              data_pk = Object.values(normalizePK);
            }
          }

          // if (wilayah.data_pus == undefined) {
          //     data_pus = Object.values(pus);
          // } else {
          //     if (Object.values(pus).length == 0) {
          //         data_pus = wilayah.data_pus;
          //     } else {
          //         data_pus = Object.values(pus);
          //     }
          // }

          // if (wilayah.data_pus_lainnya == undefined) {
          //     data_pus_lainnya = Object.values(pusLainnya);
          // } else {
          //     if (Object.values(pusLainnya).length == 0) {
          //         data_pus_lainnya = wilayah.data_pus_lainnya;
          //     } else {
          //         data_pus_lainnya = Object.values(pusLainnya);
          //     }
          // }
        } else {
          //
          data_kb = Object.values(normalizeKB);
          data_pk = Object.values(normalizePK);
          // data_pus = Object.values(pus);
          // data_pus_lainnya = Object.values(pusLainnya);
        }

        // const data_pk = Object.values(normalizePK);
        const status_draft = "1";
        const pos_draft = form;
        const subformIndex = indexForm;
        const last_update = Date.now();

        // const pertanyaan_pus = pertanyaanPus
        // const hamil_pertama_pus_lainnya = hamilPertamaLainnya
        // const jumlah_keluarga_pus_lainnya = jmlHamilLainnya

        let os = window.navigator.userAgent; //get Browser and Os Version
        let time = new Date()
          .toLocaleString()
          .replace(",", "")
          .replace(/:.. /, " ");
        const audit_trail = "Update Draft From " + os + " At " + time;

        console.log("data_kb", data_kb);

        let dataBkkbnAll = {
          ...dataKKUtama,
          periode_sensus: "2025",
          status_sensus: "",
          group: "dataBkkbn",
          data_nik,
          data_kb,
          data_pk,
          // pertanyaan_pus,
          // hamil_pertama_pus_lainnya,
          // jumlah_keluarga_pus_lainnya,
          // data_pus,
          // data_pus_lainnya,
          status_draft,
          pos_draft,
          subformIndex,
          audit_trail,
          last_update,
        };
        console.log("dataBkkbnAll", dataBkkbnAll);

        try {
          const kkDoc = await dataBkkbn.remote.get(wilayah._id);
          let dataToSave = {
            ...dataBkkbnAll,
            _rev: kkDoc._rev,
          };

          let dataToSaveLocal = {
            ...dataBkkbnAll,
            status_sensus: "Tersimpan",
          };

          //
          // await dataBkkbn['remote'].put(dataToSave);
          await axios.put(
            url +
              "/" +
              dataToSave._id +
              "/_put?couchdb=" +
              couchdb +
              "&database-name=" +
              db_name +
              "&_id=" +
              dataToSave._id +
              "&idKec=" +
              metadata?.wil_kecamatan?.id_kecamatan,
            dataToSave,
            {
              // headers: { user_key: USER_KEY_PG }
              headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
            }
          );
          await dataBkkbn["local"].put(dataToSaveLocal);

          let message =
            mode === "edit"
              ? `Data berhasil diperbarui`
              : `Data berhasil disimpan ke ${target} DB`;
          enqueueSnackbar(message, { variant: "success" });

          const id = wilayah._id;

          // setSubmitting(curr => ({ ...curr, [target]: false }));
          setSaved((curr) => ({ ...curr, [target]: true }));

          //
          history.push("/list-draft");
        } catch (e) {
          await dataBkkbn["local"].put(dataBkkbnAll);
          // setSubmitting(curr => ({ ...curr, [target]: false }));
          enqueueSnackbar("Data berhasil disimpan ke Lokal", {
            variant: "success",
          });

          history.push("/list-draft");
          if (e.message.includes("The database connection is closing")) {
            window.location.href = "/login";
          }
        }
      } else {
      }
    }
  };

  //
  //

  var buttonAlert;
  if (wilayah.status_sensus !== "Valid" && wilayah.status_draft === "2") {
    if (
      wilayah.status_sensus !== "Received" &&
      wilayah.status_sensus !== "Tersimpan" &&
      wilayah.status_sensus !== ""
    ) {
      buttonAlert = (
        <Alert
          color={
            wilayah.status_sensus === "Anomali Terkonfirmasi"
              ? "success"
              : "danger"
          }
          isOpen={visible}
          toggle={onDismiss}
        >
          <b>Alasan :</b>{" "}
          {wilayah.status_sensus === "Anomali Terkonfirmasi"
            ? wilayah.status_sensus
            : wilayah.alasan}
        </Alert>
      );
    } else {
      buttonAlert = "";
    }
  } else {
    buttonAlert = "";
  }

  return (
    <Container maxWidth="md" className={classes.container}>
      {/* {
            (wilayah.status_sensus !== 'Received' && wilayah.status_sensus !== 'Valid') && wilayah.status_draft == 2  &&
            <Alert color={(wilayah.status_sensus == 'Anomali Terkonfirmasi') ? 'success' : 'danger'} isOpen={visible} toggle={onDismiss}>
                Alasan : {wilayah.status_sensus == 'Anomali Terkonfirmasi' ? wilayah.status_sensus : wilayah.alasan}
            </Alert>
        } */}

      {buttonAlert}

      <Slide direction={slide.direction} in={slide.in}>
        <div>
          {f?.type === "wilayah" && (
            <Wilayah
              mode="edit"
              docKK={docKK}
              kb={kb}
              wilayah={wilayah}
              setWilayah={setWilayah}
              keluarga={keluarga}
              setKeluarga={setKeluarga}
              setFormIndex={setFormIndex}
              handleNext={handleNext}
              handleDraft={handleDraft}
              handleSegmen={handleSegmen}
              handleNextSegmen={handleNextSegmen}
              handleAnomali={handleAnomali}
            />
          )}

          {f?.type === "keluarga" && (
            <Keluarga
              id={f.id}
              setFormIndex={setFormIndex}
              handleNext={handleNext}
              handleBack={handleBack}
              keluarga={keluarga}
              setKeluarga={setKeluarga}
              formIndex={formIndex}
              docKK={docKK}
              mode="edit"
              kb={kb}
              no_kk={params.no_kk}
              wilayah={wilayah}
              setWilayah={setWilayah}
              handleDraft={handleDraft}
              handleSegmen={handleSegmen}
              handleNextSegmen={handleNextSegmen}
              handleBackSegmen={handleBackSegmen}
              handleAnomali={handleAnomali}
            />
          )}

          {f?.type === "kb" && (
            <KB
              setFormIndex={setFormIndex}
              handleNext={handleNext}
              handleBack={handleBack}
              mainSlide={slide}
              keluarga={keluarga}
              wilayah={wilayah}
              setWilayah={setWilayah}
              kb={kb}
              setKB={setKB}
              setNormalizeKB={setNormalizeKB}
              mode="edit"
              no_kk={params.no_kk}
              handleDraft={handleDraft}
              handleSegmen={handleSegmen}
              handleNextSegmen={handleNextSegmen}
              handleBackSegmen={handleBackSegmen}
              handleAnomali={handleAnomali}
            />
          )}

          {f?.type === "pk" && (
            <PK
              setFormIndex={setFormIndex}
              handleNext={handleNext}
              handleBack={handleBack}
              mainSlide={slide}
              keluarga={keluarga}
              wilayah={wilayah}
              setWilayah={setWilayah}
              kb={kb}
              pk={pk}
              setPK={setPK}
              setNormalizePK={setNormalizePK}
              mode="edit"
              no_kk={params.no_kk}
              handleDraft={handleDraft}
              handleSegmen={handleSegmen}
              handleNextSegmen={handleNextSegmen}
              handleBackSegmen={handleBackSegmen}
              handleAnomali={handleAnomali}
            />
          )}

          {/* {
                    f?.type === 'pertanyaan' &&

                    <PERTANYAAN
                        setFormIndex={setFormIndex}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        kb={kb}
                        pertanyaanPus={pertanyaanPus}
                        setPertanyaanPus={setPertanyaanPus}
                        mode="edit"
                        mainSlide={slide}
                        keluarga={keluarga}
                        formIndex={formIndex}
                        wilayah={wilayah}
                        handleDraft={handleDraft}
                        handleSegmen={handleSegmen}
                        handleAnomali={handleAnomali}
                        direction={slide}
                    />

                } */}

          {/* {
                    f?.type === 'pus' &&

                    <PUS
                        setFormIndex={setFormIndex}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        kb={kb}
                        pus={pus}
                        pertanyaanPus={pertanyaanPus}
                        setPus={setPus}
                        mode="edit"
                        mainSlide={slide}
                        keluarga={keluarga}
                        formIndex={formIndex}
                        wilayah={wilayah}
                        handleDraft={handleDraft}
                        handleSegmen={handleSegmen}
                        handleAnomali={handleAnomali}
                        direction={slide}
                    />

                }

                {
                    f?.type === 'hamilLainnya' &&

                    <HAMILLAINNYA
                        setFormIndex={setFormIndex}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        kb={kb}
                        jmlHamilLainnya={jmlHamilLainnya}
                        setJmlHamilLainnya={setJmlHamilLainnya}
                        hamilPertamaLainnya={hamilPertamaLainnya}
                        pertanyaanPus={pertanyaanPus}
                        setHamilPertamaLainnya={setHamilPertamaLainnya}
                        mode="edit"
                        mainSlide={slide}
                        keluarga={keluarga}
                        formIndex={formIndex}
                        wilayah={wilayah}
                        handleDraft={handleDraft}
                        handleSegmen={handleSegmen}
                        handleAnomali={handleAnomali}
                        direction={slide}
                    />

                }

                {
                    f?.type === 'pusLainnya' &&

                    <PUSLAINNYA
                        setFormIndex={setFormIndex}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        kb={kb}
                        pusLainnya={pusLainnya}
                        hamilPertamaLainnya={hamilPertamaLainnya}
                        jmlHamilLainnya={jmlHamilLainnya}
                        pertanyaanPus={pertanyaanPus}
                        setPusLainnya={setPusLainnya}
                        mode="edit"
                        mainSlide={slide}
                        keluarga={keluarga}
                        formIndex={formIndex}
                        wilayah={wilayah}
                        handleDraft={handleDraft}
                        handleSegmen={handleSegmen}
                        handleAnomali={handleAnomali}
                        direction={slide}
                    />

                } */}
        </div>
      </Slide>

      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Pemberitahuan"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Saat ini semua taransaksi Insert atau Edit data telah ditutup
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Tutup
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog
          open={openTotalTarget}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Pemberitahuan"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Progres pendataan telah mencapai target
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Tutup
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Container>
  );
}
